module.exports = "/_next/static/images/9a9ceae7813b89bf88c5404732a887ee-pregnant-woman@desktop@3x.jpg.webp";